export default "__VITE_ASSET__d2c17eb6__"